import styled from 'styled-components'

export const Carouselcaption = styled.div`
position:absolute;
top:10%;
left:33%;
transform:translate(50%,50%)
`

export const Img = styled.img`
height:100vh;
@media screen and (max-width:768px){
    height:50vh;
}
`